:host {
  position: relative;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.header {
  padding: calc(2 * var(--spacer));
}

.content {
  display: flex;
  align-items: stretch;
  height: 100%;
}

.new-maintenance-window {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  background: var(--white-layout-301-level-0-elevation);
}
